/**
 * Shared tone colors for dark demo workbench surfaces.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

export type DemoWorkbenchTone = "default" | "accent" | "danger" | "success" | "warning";

export interface DemoWorkbenchToneColor {
  readonly bg: string;
  readonly border: string;
  readonly fg: string;
}

export const DEMO_WORKBENCH_TONE_COLORS: Readonly<
  Record<DemoWorkbenchTone, DemoWorkbenchToneColor>
> = {
  accent: {
    bg: "rgba(56, 189, 248, 0.12)",
    border: "rgba(56, 189, 248, 0.42)",
    fg: "#38bdf8",
  },
  danger: {
    bg: "rgba(248, 113, 113, 0.12)",
    border: "rgba(248, 113, 113, 0.42)",
    fg: "#f87171",
  },
  default: {
    bg: "rgba(30, 41, 59, 0.72)",
    border: "rgba(100, 116, 139, 0.42)",
    fg: "#e2e8f0",
  },
  success: {
    bg: "rgba(34, 197, 94, 0.12)",
    border: "rgba(34, 197, 94, 0.42)",
    fg: "#22c55e",
  },
  warning: {
    bg: "rgba(245, 158, 11, 0.12)",
    border: "rgba(245, 158, 11, 0.42)",
    fg: "#f59e0b",
  },
};

export function getDemoWorkbenchToneColor(tone: DemoWorkbenchTone): DemoWorkbenchToneColor {
  return DEMO_WORKBENCH_TONE_COLORS[tone];
}
